<div class="modal fade" tabindex="-1" role="dialog" id="analise-venda-bi01-filtro">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 translate class="modal-title">{{'rmpv.analiseVenda.filtros.definirFiltros'}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <!--      <div class="modal-body">-->
            <div class="container striped-rows">
                <div class="row ptb5">
                    <div translate class="col col-4">
                        {{'rmpv.analiseVenda.filtros.mercado'}}
                    </div>
                    <div class="col col-8">
                        <select class="form-control form-control-sm" type="text" placeholder="Selecione o Mercado..."
                            [(ngModel)]="Mercado">
                            <option translate value="">{{'rmpv.analiseVenda.filtros.mercadoPlaceHolder'}}</option>
                            <option *ngFor="let item of mercado" [value]="item.id">{{item.descricao}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ptb5">
                    <div translate class="col col-4">
                        {{'rmpv.analiseVenda.filtros.grupoEconomico'}}
                    </div>
                    <div class="col col-8" name="GrupoEconomico">
                        <select class="form-control form-control-sm" type="text" (change)="selecionaDealer()"
                            [(ngModel)]="GrupoEconomico" placeholder="Selecione o grupo econômico...">
                            <option translate value="">{{'rmpv.analiseVenda.filtros.grupoEconomicoPlaceHolder'}}
                            </option>
                            <option *ngFor="let item of gruposEconomicos" [value]="item.id"> {{item.descricao}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row ptb5">
                    <div translate class="col col-4">
                        {{'rmpv.analiseVenda.filtros.regiao'}}
                    </div>
                    <div class="col col-8">
                        <select class="form-control form-control-sm" type="number" placeholder="Selecione a Região..."
                            [(ngModel)]="Regiao">
                            <option translate value="">{{'rmpv.analiseVenda.filtros.regiaoPlaceHolder'}}</option>
                            <option *ngFor="let item of regioes" [value]="item.id">{{item.descricao}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ptb5">
                    <div translate class="col col-4">
                        Dealer
                    </div>
                    <div class="col col-8">
                        <select class="form-control form-control-sm" type="number" [(ngModel)]="Dealer">
                            <option translate value="">{{'rmpv.analiseVenda.filtros.dealerPlaceHolder'}}</option>
                            <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ptb5">
                    <div translate class="col col-4">
                        {{'rmpv.analiseVenda.filtros.mesInicial'}}
                    </div>
                    <div class="col col-8">
                        <select class="form-control form-control-sm" type="text" placeholder="Selecione o mês inicial..."
                            [(ngModel)]="filtros.mes_inicial" [(ngModel)]="mes_inicial">
                            <option translate value=1>{{'rmpv.analiseVenda.filtros.meses.janeiro'}}</option>
                            <option translate value=2>{{'rmpv.analiseVenda.filtros.meses.fevereiro'}}</option>
                            <option translate value=3>{{'rmpv.analiseVenda.filtros.meses.marco'}}</option>
                            <option translate value=4>{{'rmpv.analiseVenda.filtros.meses.abril'}}</option>
                            <option translate value=5>{{'rmpv.analiseVenda.filtros.meses.maio'}}</option>
                            <option translate value=6>{{'rmpv.analiseVenda.filtros.meses.junho'}}</option>
                            <option translate value=7>{{'rmpv.analiseVenda.filtros.meses.julho'}}</option>
                            <option translate value=8>{{'rmpv.analiseVenda.filtros.meses.agosto'}}</option>
                            <option translate value=9>{{'rmpv.analiseVenda.filtros.meses.setembro'}}</option>
                            <option translate value=10>{{'rmpv.analiseVenda.filtros.meses.outubro'}}</option>
                            <option translate value=11>{{'rmpv.analiseVenda.filtros.meses.novembro'}}</option>
                            <option translate value=12>{{'rmpv.analiseVenda.filtros.meses.dezembro'}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ptb5">
                    <div translate class="col col-4">
                        {{'rmpv.analiseVenda.filtros.mesFinal'}}
                    </div>
                    <div class="col col-8">
                        <select class="form-control form-control-sm" type="text" placeholder="Selecione o mês final..."
                            [(ngModel)]="filtros.mes_final" [(ngModel)]="mes_final">
                            <option translate value=1>{{'rmpv.analiseVenda.filtros.meses.janeiro'}}</option>
                            <option translate value=2>{{'rmpv.analiseVenda.filtros.meses.fevereiro'}}</option>
                            <option translate value=3>{{'rmpv.analiseVenda.filtros.meses.marco'}}</option>
                            <option translate value=4>{{'rmpv.analiseVenda.filtros.meses.abril'}}</option>
                            <option translate value=5>{{'rmpv.analiseVenda.filtros.meses.maio'}}</option>
                            <option translate value=6>{{'rmpv.analiseVenda.filtros.meses.junho'}}</option>
                            <option translate value=7>{{'rmpv.analiseVenda.filtros.meses.julho'}}</option>
                            <option translate value=8>{{'rmpv.analiseVenda.filtros.meses.agosto'}}</option>
                            <option translate value=9>{{'rmpv.analiseVenda.filtros.meses.setembro'}}</option>
                            <option translate value=10>{{'rmpv.analiseVenda.filtros.meses.outubro'}}</option>
                            <option translate value=11>{{'rmpv.analiseVenda.filtros.meses.novembro'}}</option>
                            <option translate value=12>{{'rmpv.analiseVenda.filtros.meses.dezembro'}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ptb5">
                    <div translate class="col col-4">
                        {{'rmpv.analiseVenda.filtros.ano'}}
                    </div>
                    <div class="col col-8">
                        <select class="form-control form-control-sm" type="text" placeholder="Selecione o ano..."
                            [(ngModel)]="filtros.ano" [(ngModel)]="ano">
                            <option *ngFor="let ano of anoDropDown" value={{ano.value}}>{{ano.value}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="limpaFiltro()">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
            </div>
        </div>
    </div>
</div>